import styled, { css } from 'styled-components';

interface MarginProps {
  top?: number;
  bottom?: number;
  left?: number;
  right?: number;
}

export const Margin = styled.div<MarginProps>`
  ${({ top, bottom, left, right }) => css`
    margin-top: ${top || 0}px;
    margin-bottom: ${bottom || 0}px;
    margin-left: ${left || 0}px;
    margin-right: ${right || 0}px;
  `}
`;

export const Padding = styled.div<MarginProps>`
  ${({ top, bottom, left, right }) => css`
    padding-top: ${top || 0}px;
    padding-bottom: ${bottom || 0}px;
    padding-left: ${left || 0}px;
    padding-right: ${right || 0}px;
  `}
`;

export const LoadingStateWrapper = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  padding: 16px 0 24px;
`;

export const shakeAnimation = css`
  @keyframes shake {
    0% {
      transform: translate(1px, 1px) rotate(0deg);
    }
    10% {
      transform: translate(-1px, -2px) rotate(-1deg);
    }
    20% {
      transform: translate(-3px, 0px) rotate(1deg);
    }
    30% {
      transform: translate(3px, 2px) rotate(0deg);
    }
    40% {
      transform: translate(1px, -1px) rotate(1deg);
    }
    50% {
      transform: translate(-1px, 2px) rotate(-1deg);
    }
    60% {
      transform: translate(-3px, 1px) rotate(0deg);
    }
    70% {
      transform: translate(3px, 1px) rotate(-1deg);
    }
    80% {
      transform: translate(-1px, -1px) rotate(1deg);
    }
    90% {
      transform: translate(1px, 2px) rotate(0deg);
    }
    100% {
      transform: translate(1px, -2px) rotate(-1deg);
    }
  }
`;

// Apply this style to overrider alignment in case of mobile preview and default to center
export const overrideAlignmentForMobilePreviewMode = css`
  @media only screen and (max-width: 768px) {
    align-items: center;
    text-align: center;
  }
`;

export const LeadCaptureFormWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 100;
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;

  /* Extra tiny devices (phones, 350px and down) */
  @media only screen and (max-width: 350px) {
    zoom: 0.5;
  }

  /* Extra small devices (phones, 350px and up) */
  @media only screen and (min-width: 350px) {
    zoom: 0.6;
  }

  /* Small devices (portrait tablets and large phones, 600px and up) */
  @media only screen and (min-width: 600px) {
    zoom: 0.8;
  }

  /* Medium devices (landscape tablets, 768px and up) */
  @media only screen and (min-width: 768px) {
    zoom: 0.9;
  }

  /* Large devices (laptops/desktops, 992px and up) */
  @media only screen and (min-width: 992px) {
    zoom: 1;
  }
`;
